<template>
  <div v-if="navLinks.length > 0" class="nav-section">
    <v-list-item>
      <v-list-item-content class="menu_title" @click="$emit('toggle')">
        {{ title }}
      </v-list-item-content>
      <v-list-item-icon class="toggle" @click="$emit('toggle')">
        <v-icon color="bright" v-if="expanded">mdi-chevron-left</v-icon>
        <v-icon color="bright" v-else>mdi-chevron-right</v-icon>
      </v-list-item-icon>
    </v-list-item>
    <template v-for="navLink in navLinks">
      <v-tooltip right :key="navLink.route" :disabled="!navLink.description">
        <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <v-list-item
            v-show="expanded"
            class="bright--text ml-3"
            :to="navLink.route"
            link
            v-bind="tooltipAttrs"
            v-on="tooltipOn"
          >
            <v-list-item-icon class="mr-2">
              <v-icon color="bright">{{ navLink.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $t(navLink.text) }}
            </v-list-item-content>
            <v-list-item-action
              class="fav-action ml-0 my-0"
              :class="{ 'fav-active': isFavorite(navLink.route) }"
            >
              <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-btn
                    icon
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    @click.prevent.stop="
                      $emit('toggle-favorite', navLink.route)
                    "
                  >
                    <v-icon
                      small
                      :color="isFavorite(navLink.route) ? 'amber' : 'grey'"
                    >
                      {{
                        isFavorite(navLink.route)
                          ? 'mdi-star'
                          : 'mdi-star-outline'
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('common.toggleFavorite') }}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </template>
        <span>{{ $t(navLink.description) }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  name: 'NavMenuSection',
  props: {
    title: {
      type: String,
      required: true,
    },
    navLinks: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    favorites: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isFavorite(route) {
      return this.favorites.includes(route)
    },
  },
}
</script>

<style scoped>
.nav-section {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 4px;
  margin-bottom: 4px;
}

.nav-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.menu_title {
  font-size: 13px;
  font-weight: 500;
  color: white;
  user-select: none;
  cursor: pointer;
  transition: all 0.2s ease;
}
.menu_title:hover {
  color: #b0bec5;
}
.toggle {
  color: white;
  cursor: pointer;
}

/* Favorite action */
.fav-action {
  min-width: 24px !important;
  opacity: 0;
  transition: opacity 0.2s ease;
}

::v-deep .v-list-item:hover .fav-action {
  opacity: 1;
}

.fav-active {
  opacity: 1 !important;
}
</style>
